import { QUERY_STRING_KEY_BLOCK_LIST } from '../../constants/queryString';

export function isAllowedSearchQueryKey(key: string) {
  return !QUERY_STRING_KEY_BLOCK_LIST.includes(key);
}
